// Frittstående Kontakter (poppet ut til egen skjerm). Bla i HV-enheter + lagrede
// GNÅ-kontakter; lagrede kontakter persisteres lokalt (samme nøkkel som hoved-COP).
import type { Contact } from '@skade/contracts';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import type { User } from '@skade/rbac';
import { sokGnaBrukere } from '../gna-katalog.js';
import { DirectoryPanel } from '../ui/directory.js';

export function mountDirectoryPanel(root: HTMLElement, feed: Feed, _sync: SyncBus, user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const wrap = document.createElement('div');
  wrap.className = 'standalone-panel';
  const head = document.createElement('div');
  head.className = 'standalone-head';
  head.append(span('brand', 'SKADE'), span('standalone-title', 'Kontakter'));
  wrap.append(head);

  const key = `skade.contacts.${user.org?.district ?? 'na'}`;
  const saved = new Map<string, Contact>();
  try {
    const raw = JSON.parse(localStorage.getItem(key) ?? '[]');
    if (Array.isArray(raw)) for (const c of raw) if (c?.id) saved.set(c.id, { id: c.id, name: c.name || c.id, source: 'saved' });
  } catch { /* korrupt cache */ }
  const persist = () => { try { localStorage.setItem(key, JSON.stringify([...saved.values()])); } catch { /* full */ } };
  const domain = user.id.includes(':') ? user.id.split(':').slice(1).join(':') : 'matrix.follodefence.com';

  const dir = new DirectoryPanel({
    getSaved: () => [...saved.values()],
    getSeen: () => [],
    onAdd: (name, id) => { saved.set(id, { id, name, source: 'saved' }); persist(); },
    onRemove: (id) => { saved.delete(id); persist(); },
    onMessage: (mxid) => { try { window.navigator.clipboard?.writeText(mxid); } catch { /* ignorer */ } },
    defaultDomain: domain,
    // Samme katalog som i hovedvinduet — popout skal ikke være en dårligere
    // utgave av panelet.
    sokGnaBrukere,
  }, true);
  wrap.append(dir.el);
  root.append(wrap);
  feed.start();
}

function span(cls: string, text: string): HTMLElement { const e = document.createElement('span'); e.className = cls; e.textContent = text; return e; }
